import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Attachment, Emoji } from 'components/composer/shared/editor_action_buttons';
import CreditCardRequestButton from 'components/composer/chat/credit_card_request_button_container';

const ComposerButtonsContainer = styled.div`
  display: flex;
`;

export default function ComposerButtons({ editorRef }) {
  return (
    <ComposerButtonsContainer>
      <Emoji editorRef={editorRef} />
      <CreditCardRequestButton data-aid={'credit-card-request-button'} />
      <Attachment data-aid="attachment-styles" />
    </ComposerButtonsContainer>
  );
}

ComposerButtons.propTypes = {
  editorRef: PropTypes.shape({ current: PropTypes.any }),
};
